import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { MENU_ITEM_TYPES } from '../../../../../utils/constants/enums.js';

const MenuTable = ({ menu, onDelete, onDetailClick }) => {
  const { t } = useTranslation();

  // Funkcia na získanie labelu z ENUM podľa ID
  const getItemTypeLabel = (itemTypeId) => {
    const itemType = Object.values(MENU_ITEM_TYPES).find(
      (type) => type.id === itemTypeId,
    );
    return itemType ? itemType.label : itemTypeId; // Ak nenájdem label, vrátim ID
  };

  const textSkTextFilterProps = useDataGridTextFilter('text_sk');
  const textEnTextFilterProps = useDataGridTextFilter('text_en');
  const locationTextFilterProps = useDataGridTextFilter('location');

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Názov (slovensky)'),
        dataIndex: 'text_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('text_sk'),
        render: (text_sk) => text_sk || '-',
        ...textSkTextFilterProps,
      },
      {
        title: t('Názov (anglicky)'),
        dataIndex: 'text_en',
        ellipsis: true,
        sorter: dataGridTextSorter('text_en'),
        render: (text_en) => text_en || '-',
        ...textEnTextFilterProps,
      },
      {
        title: t('Typ odkazu'),
        dataIndex: 'item_type',
        render: (item_type) => getItemTypeLabel(item_type), // Získanie a zobrazenie labelu podľa ID
        sorter: dataGridTextSorter('item_type'),
        width: 150,
      },
      {
        title: t('Umiestnenie v SK menu'),
        dataIndex: 'location_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('location'),
        render: (location_sk) => location_sk || '-',
        ...locationTextFilterProps,
      },
      {
        title: t('Umiestnenie v EN menu'),
        dataIndex: 'location_en',
        ellipsis: true,
        sorter: dataGridTextSorter('location'),
        render: (location_en) => location_en || '-',
        ...locationTextFilterProps,
      },
    ],
    [t, textSkTextFilterProps, textEnTextFilterProps, locationTextFilterProps],
  );

  return (
    <>
      <DataGrid
        rowKey={(menuItem) => menuItem.id}
        columns={dataGridColumns}
        dataSource={menu || []}
        permissionsBasic={'menu'}
        uniqueTableId={'menu-table'}
        onDelete={onDelete}
        onEditClick={onDetailClick}
        onRowClick={onDetailClick}
      />
    </>
  );
};

MenuTable.propTypes = {
  menu: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default MenuTable;
